import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/assets/filter.svg'
import _imports_1 from '@/assets/filterIcon_Disabled.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "flex justify-between items-center h-8" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_7 = { class: "mt-5 bg-white border border-lightgrey relative rounded" }
const _hoisted_8 = { class: "pt-5 px-5 pb-5 flex flex-col h-full w-full" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "noScrollbar tabStructure1 overflow-y-auto"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "noScrollbar tabStructure overflow-y-auto"
}
const _hoisted_15 = { class: "statuscontainer" }
const _hoisted_16 = { class: "formcontainer flex flex-col" }
const _hoisted_17 = { class: "w-full upperspacing" }
const _hoisted_18 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_19 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_20 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_21 = { class: "w-6/12" }
const _hoisted_22 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_23 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_24 = { class: "w-6/12 leftspacing" }
const _hoisted_25 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_26 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_27 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_28 = { class: "w-6/12" }
const _hoisted_29 = { class: "w-6/12 leftspacing" }
const _hoisted_30 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_31 = { class: "w-6/12" }
const _hoisted_32 = { class: "w-6/12 leftspacing" }
const _hoisted_33 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_34 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_35 = {
  key: 0,
  class: "row flex flex-row w-full upperspacing"
}
const _hoisted_36 = { class: "w-6/12" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = {
  key: 0,
  class: "bottom-7 bg-white h-14 flex justify-end items-center w-full rounded-b-sm",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_44 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_45 = { class: "formcontainer flex flex-col" }
const _hoisted_46 = { class: "w-full upperspacing" }
const _hoisted_47 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_48 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_51 = { class: "row flex flex-row w-full" }
const _hoisted_52 = { class: "w-6/12" }
const _hoisted_53 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_54 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_55 = { class: "w-3/6 leftspacing" }
const _hoisted_56 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_57 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_58 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_59 = { class: "w-full" }
const _hoisted_60 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_61 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_64 = { class: "row flex flex-row w-full" }
const _hoisted_65 = { class: "w-6/12" }
const _hoisted_66 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_67 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_68 = { class: "w-6/12 leftspacing" }
const _hoisted_69 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_70 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_71 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_72 = { class: "w-full" }
const _hoisted_73 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_74 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_77 = { class: "row flex flex-row w-full" }
const _hoisted_78 = { class: "w-6/12" }
const _hoisted_79 = ["value"]
const _hoisted_80 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_81 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_82 = { class: "w-6/12 leftspacing" }
const _hoisted_83 = ["value"]
const _hoisted_84 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_85 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_86 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_87 = { class: "row flex flex-row w-full" }
const _hoisted_88 = { class: "w-6/12" }
const _hoisted_89 = ["value"]
const _hoisted_90 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_91 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_92 = { class: "w-6/12 leftspacing" }
const _hoisted_93 = ["value"]
const _hoisted_94 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_95 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_96 = { class: "formcontainer upperspacing" }
const _hoisted_97 = { class: "row flex flex-row w-full" }
const _hoisted_98 = { class: "w-3/6" }
const _hoisted_99 = ["value"]
const _hoisted_100 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_101 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_102 = { class: "w-3/6 leftspacing" }
const _hoisted_103 = ["value"]
const _hoisted_104 = { class: "buttonposition flex justify-center items-center mt-2 mb-4 mx-0" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = ["disabled"]
const _hoisted_107 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Select = _resolveComponent("Select")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.information.information), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.selectedIndex != 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass([_ctx.selectedIndex == 0 && _ctx.riskList.length != 0 ? 'filterButton' : 'btndisabled pointer-events-none', "flex"]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              (_ctx.selectedIndex == 0 && _ctx.riskList.length != 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : (_openBlock(), _createElementBlock("img", _hoisted_6)),
              _cache[35] || (_cache[35] = _createTextVNode(" Filters "))
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Tabs, {
          value: _ctx.selectedIndex,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedIndex) = $event)),
          scrollable: "",
          class: "heightFixing pr-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_TabList, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                    return (_openBlock(), _createBlock(_component_Tab, {
                      key: tab.id,
                      value: tab.id,
                      onClick: ($event: any) => (_ctx.toggleTabs(tab))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tab.displayName), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                  return (_openBlock(), _createBlock(_component_TabPanel, {
                    key: tab.id,
                    value: tab.id
                  }, {
                    default: _withCtx(() => [
                      (_ctx.dataLoading == true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_dots_loader)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (tab.id == 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_component_newTable, {
                                    tableRowData: _ctx.riskList,
                                    headersData: _ctx.riskHeaders,
                                    openPopup: true,
                                    navigate: false,
                                    loadData: _ctx.dataLoading
                                  }, null, 8, ["tableRowData", "headersData", "loadData"]),
                                  (_ctx.toolTipActive)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (tab.id == 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_15, [
                                      _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                          _cache[37] || (_cache[37] = _createElementVNode("label", { class: "controllabel" }, "Information Category", -1)),
                                          _createVNode(_component_AutoComplete, {
                                            modelValue: _ctx.information.informationCategory,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.information.informationCategory) = $event)),
                                            suggestions: _ctx.filteredCategories,
                                            onComplete: _ctx.searchCategory,
                                            placeholder: "Information Category",
                                            field: "label",
                                            class: _normalizeClass(["w-full", {
                                            'is-invalidmultiselect': _ctx.v$.information.informationCategory.$error,
                                            'has-options': _ctx.filteredCategories && _ctx.filteredCategories.length > 0,
                                            'no-options':  !_ctx.filteredCategories.length,
                                        }])
                                          }, {
                                            empty: _withCtx(() => _cache[36] || (_cache[36] = [
                                              _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                            ])),
                                            _: 1
                                          }, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                                          (_ctx.v$.information.informationCategory.$error)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                (_ctx.v$.information.informationCategory.required.$invalid)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Required"))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_20, [
                                          _createElementVNode("div", _hoisted_21, [
                                            _cache[39] || (_cache[39] = _createElementVNode("label", { class: "controllabel" }, "Information", -1)),
                                            _createVNode(_component_AutoComplete, {
                                              modelValue: _ctx.information.information,
                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.information.information) = $event)),
                                              suggestions: _ctx.filteredInformation,
                                              onComplete: _ctx.searchInformation,
                                              disabled: _ctx.information.informationCategory=='',
                                              placeholder: "Information",
                                              field: "label",
                                              class: _normalizeClass(["w-full", {
                                                'is-invalidmultiselect': _ctx.v$.information.information.$error,
                                                'has-options': _ctx.filteredInformation && _ctx.filteredInformation.length > 0,
                                                'no-options':  !_ctx.filteredInformation.length,
                                            }])
                                            }, {
                                              empty: _withCtx(() => _cache[38] || (_cache[38] = [
                                                _createElementVNode("span", { class: "text-xs" }, "No Information Found", -1)
                                              ])),
                                              _: 1
                                            }, 8, ["modelValue", "suggestions", "onComplete", "disabled", "class"]),
                                            (_ctx.v$.information.information.$error)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                  (_ctx.v$.information.information.required.$invalid)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Required"))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_24, [
                                            _cache[41] || (_cache[41] = _createElementVNode("label", { class: "controllabel" }, "Information Owner", -1)),
                                            _createVNode(_component_AutoComplete, {
                                              modelValue: _ctx.information.informationOwner,
                                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.information.informationOwner) = $event)),
                                              suggestions: _ctx.userOptions,
                                              onComplete: _ctx.asyncFind,
                                              optionLabel: "label",
                                              optionValue: "value",
                                              forceSelection: "",
                                              placeholder: "Info Owner",
                                              class: _normalizeClass(["custom-multiselect w-full", {
                                                'p-invalid': _ctx.v$.information.informationOwner.$error,
                                                'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
                                                'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '',
                                            }])
                                            }, {
                                              empty: _withCtx(() => _cache[40] || (_cache[40] = [
                                                _createElementVNode("span", { class: "text-xs" }, "No Members Found", -1)
                                              ])),
                                              _: 1
                                            }, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                                            (_ctx.v$.information.informationOwner.$error)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                  (_ctx.v$.information.informationOwner.required.$invalid)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Required"))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_27, [
                                          _createElementVNode("div", _hoisted_28, [
                                            _cache[42] || (_cache[42] = _createElementVNode("label", { class: "controllabel" }, "Confidentiality", -1)),
                                            _createVNode(_component_Select, {
                                              modelValue: _ctx.information.confidentiality,
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.information.confidentiality) = $event)),
                                              options: _ctx.dbConfidentiality,
                                              optionLabel: "key",
                                              optionValue: "value",
                                              placeholder: "Please select one",
                                              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getMaxIdValue())),
                                              class: "custom-multiselect w-full"
                                            }, null, 8, ["modelValue", "options"])
                                          ]),
                                          _createElementVNode("div", _hoisted_29, [
                                            _cache[43] || (_cache[43] = _createElementVNode("label", { class: "controllabel" }, "Integrity", -1)),
                                            _createVNode(_component_Select, {
                                              modelValue: _ctx.information.integrity,
                                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.information.integrity) = $event)),
                                              options: _ctx.dbIntegrity,
                                              optionLabel: "key",
                                              optionValue: "value",
                                              placeholder: "Please select one",
                                              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getMaxIdValue())),
                                              class: "custom-multiselect w-full"
                                            }, null, 8, ["modelValue", "options"])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_30, [
                                          _createElementVNode("div", _hoisted_31, [
                                            _cache[44] || (_cache[44] = _createElementVNode("label", { class: "controllabel" }, "Availability", -1)),
                                            _createVNode(_component_Select, {
                                              modelValue: _ctx.information.availability,
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.information.availability) = $event)),
                                              options: _ctx.dbAvailability,
                                              optionLabel: "key",
                                              optionValue: "value",
                                              placeholder: "Please select one",
                                              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getMaxIdValue())),
                                              class: "custom-multiselect w-full"
                                            }, null, 8, ["modelValue", "options"])
                                          ]),
                                          _createElementVNode("div", _hoisted_32, [
                                            _cache[45] || (_cache[45] = _createElementVNode("label", { class: "controllabel" }, "Classification", -1)),
                                            _createVNode(_component_Select, {
                                              modelValue: _ctx.information.classification,
                                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.information.classification) = $event)),
                                              options: _ctx.dbInformationClassification,
                                              optionLabel: "key",
                                              optionValue: "value",
                                              placeholder: "Please select one",
                                              class: "custom-multiselect w-full"
                                            }, null, 8, ["modelValue", "options"]),
                                            (_ctx.v$.information.classification.$error)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                  (_ctx.v$.information.classification.required.$invalid)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Required"))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        (_ctx.information.securityCategory != '' && !_ctx.addInfo)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                              _createElementVNode("div", _hoisted_36, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSecurityCategory, (dataValue, indexNum) => {
                                                  return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                                    (_ctx.information.securityCategory == dataValue.value)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                          _cache[46] || (_cache[46] = _createElementVNode("label", { class: "controllabel" }, "Security Category", -1)),
                                                          _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            class: "disabledinputboxstyling",
                                                            disabled: "",
                                                            "onUpdate:modelValue": ($event: any) => ((dataValue.key) = $event),
                                                            placeholder: "Security Category"
                                                          }, null, 8, _hoisted_38), [
                                                            [_vModelText, dataValue.key]
                                                          ])
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                }), 128))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      (!_ctx.dataLoading && _ctx.selectedIndex==1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("button", {
              disabled: _ctx.clickOnButton,
              class: _normalizeClass(["btnprimary mr-2", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onCancelbtn()))
            }, "Reset", 10, _hoisted_40),
            (!_ctx.information._id)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  disabled: _ctx.clickOnButton,
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addOrUpdateInformation())),
                  class: _normalizeClass(_ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none')
                }, "Save", 10, _hoisted_41))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: _ctx.clickOnButton,
                  class: _normalizeClass(["btnprimary mr-2", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addOrUpdateInformation(_ctx.information)))
                }, "Update", 10, _hoisted_42))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.openRiskPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.openRiskPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_43, [
              _cache[48] || (_cache[48] = _createElementVNode("h1", null, "Risk Information", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onCancelButton('close')))
              }, _cache[47] || (_cache[47] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_46, [
                          _cache[50] || (_cache[50] = _createElementVNode("label", { class: "controllabel" }, "Risk", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            type: "text",
                            class: _normalizeClass(["inputboxstyling", { 'is-invalid': _ctx.v$.orgRisksTab.risk.$error||_ctx.displayErrorMessageOfRisk }]),
                            onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.restrictCharacters('Risk'))),
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.orgRisksTab.risk) = $event)),
                            placeholder: "Risk"
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.orgRisksTab.risk,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.orgRisksTab.risk.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                (_ctx.v$.orgRisksTab.risk.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_ctx.displayErrorMessageOfRisk == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, _cache[49] || (_cache[49] = [
                                  _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                ])))
                              : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _cache[52] || (_cache[52] = _createElementVNode("label", { class: "controllabel" }, "Risk Category", -1)),
                          _createVNode(_component_multiselect, {
                            modelValue: _ctx.orgRisksTab.riskCategory,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.orgRisksTab.riskCategory) = $event)),
                            options: _ctx.riskCategoryList,
                            multiple: false,
                            "close-on-select": true,
                            "clear-on-select": true,
                            "open-direction": "bottom",
                            "hide-selected": true,
                            searchable: true,
                            hideArrow: false,
                            placeholder: "Risk Category",
                            deselectLabel: "",
                            showNoOptions: false,
                            selectLabel: "",
                            class: _normalizeClass(["custom-multiselect userSelect", {
                                                        'is-invalidmultiselect': _ctx.v$.orgRisksTab.riskCategory.$error,
                                                        'has-options': _ctx.riskCategoryList && _ctx.riskCategoryList.length > 0,
                                                        'no-options':  !_ctx.riskCategoryList.length,
                                                    }])
                          }, {
                            noResult: _withCtx(() => _cache[51] || (_cache[51] = [
                              _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                            ])),
                            _: 1
                          }, 8, ["modelValue", "options", "class"]),
                          (_ctx.v$.orgRisksTab.riskCategory.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                (_ctx.v$.orgRisksTab.riskCategory.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _cache[54] || (_cache[54] = _createElementVNode("label", { class: "controllabel" }, "Risk Owner", -1)),
                          _createVNode(_component_multiselect, {
                            modelValue: _ctx.orgRisksTab.riskOwner,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.orgRisksTab.riskOwner) = $event)),
                            options: _ctx.userOptions,
                            showNoOptions: false,
                            onSearchChange: _ctx.asyncFind,
                            "limit-text": _ctx.limitText,
                            multiple: false,
                            "hide-selected": true,
                            "close-on-select": true,
                            "clear-on-select": true,
                            "open-direction": "bottom",
                            label: "label",
                            "track-by": "value",
                            searchable: true,
                            hideArrow: false,
                            placeholder: "Info Owner",
                            class: _normalizeClass(["custom-multiselect userSelect", {
                                                'is-invalidmultiselect': _ctx.v$.orgRisksTab.riskOwner.$error,
                                                'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
                                                'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '',
                                            }])
                          }, {
                            noResult: _withCtx(() => _cache[53] || (_cache[53] = [
                              _createElementVNode("span", { class: "text-xs" }, "No Members Found", -1)
                            ])),
                            _: 1
                          }, 8, ["modelValue", "options", "onSearchChange", "limit-text", "class"]),
                          (_ctx.v$.orgRisksTab.riskOwner.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                (_ctx.v$.orgRisksTab.riskOwner.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_59, [
                          _cache[56] || (_cache[56] = _createElementVNode("label", { class: "controllabel" }, "Threat", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            type: "text",
                            class: _normalizeClass(["inputboxstyling", { 'is-invalid': _ctx.v$.orgRisksTab.threatEvent.$error||_ctx.displayErrorMessageOfThreat }]),
                            onInput: _cache[20] || (_cache[20] = ($event: any) => (_ctx.restrictCharacters('Threat'))),
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.orgRisksTab.threatEvent) = $event)),
                            placeholder: "Threat"
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.orgRisksTab.threatEvent,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.orgRisksTab.threatEvent.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                (_ctx.v$.orgRisksTab.threatEvent.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_ctx.displayErrorMessageOfThreat == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_62, _cache[55] || (_cache[55] = [
                                  _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                ])))
                              : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _cache[58] || (_cache[58] = _createElementVNode("label", { class: "controllabel" }, "Threat Source", -1)),
                          _createVNode(_component_multiselect, {
                            modelValue: _ctx.orgRisksTab.threatSource,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.orgRisksTab.threatSource) = $event)),
                            options: _ctx.threatSourceList,
                            searchable: true,
                            "close-on-select": true,
                            "show-labels": false,
                            "hide-selected": true,
                            placeholder: "Threat Source",
                            "open-direction": "bottom",
                            class: _normalizeClass(["custom-multiselect", {
                                                'is-invalidmultiselect': _ctx.v$.orgRisksTab.threatSource.$error,
                                                'has-options': _ctx.threatSourceList && _ctx.threatSourceList.length > 0,
                                                'no-options':  !_ctx.threatSourceList.length,
                                            }])
                          }, {
                            noResult: _withCtx(() => _cache[57] || (_cache[57] = [
                              _createElementVNode("span", { class: "text-xs" }, "No Source Found", -1)
                            ])),
                            _: 1
                          }, 8, ["modelValue", "options", "class"]),
                          (_ctx.v$.orgRisksTab.threatSource.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                (_ctx.v$.orgRisksTab.threatSource.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _cache[60] || (_cache[60] = _createElementVNode("label", { class: "controllabel" }, "Threat Category", -1)),
                          _createVNode(_component_multiselect, {
                            modelValue: _ctx.orgRisksTab.threatCategory,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.orgRisksTab.threatCategory) = $event)),
                            options: _ctx.threatCategoryList,
                            searchable: true,
                            "close-on-select": true,
                            "show-labels": false,
                            "hide-selected": true,
                            placeholder: "Threat Category",
                            "open-direction": "bottom",
                            class: _normalizeClass(["custom-multiselect", {
                                                'is-invalidmultiselect': _ctx.v$.orgRisksTab.threatCategory.$error,
                                                'has-options': _ctx.threatCategoryList && _ctx.threatCategoryList.length > 0,
                                                'no-options':  !_ctx.threatCategoryList.length,
                                            }])
                          }, {
                            noResult: _withCtx(() => _cache[59] || (_cache[59] = [
                              _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                            ])),
                            _: 1
                          }, 8, ["modelValue", "options", "class"]),
                          (_ctx.v$.orgRisksTab.threatCategory.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                (_ctx.v$.orgRisksTab.threatCategory.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_72, [
                          _cache[62] || (_cache[62] = _createElementVNode("label", { class: "controllabel" }, "Vulnerability", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            type: "text",
                            class: _normalizeClass(["inputboxstyling", { 'is-invalid': _ctx.v$.orgRisksTab.vulnerability.$error||_ctx.displayErrorMessageOfVulnerability }]),
                            onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.restrictCharacters('Vulnerability'))),
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.orgRisksTab.vulnerability) = $event)),
                            placeholder: "Vulnerability"
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.orgRisksTab.vulnerability,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.orgRisksTab.vulnerability.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                (_ctx.v$.orgRisksTab.vulnerability.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_ctx.displayErrorMessageOfVulnerability == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_75, _cache[61] || (_cache[61] = [
                                  _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                ])))
                              : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _cache[75] || (_cache[75] = _createElementVNode("h1", { class: "upperspacing" }, "Impact Analysis", -1)),
                    _cache[76] || (_cache[76] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _cache[64] || (_cache[64] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["inputboxstylingForSelect", { 'is-invalid': _ctx.v$.orgRisksTab.business.$error,'inputboxstylingForSelectAtPopup': _ctx.orgRisksTab.business === '','stylingForInputboxstylingForSelectAtPopup': _ctx.orgRisksTab.business !== ''  }]),
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.orgRisksTab.business) = $event))
                          }, [
                            _cache[63] || (_cache[63] = _createElementVNode("option", {
                              value: "",
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, "Please select one", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbBussiness, (i) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "optionColors",
                                value: i.value,
                                key: i
                              }, _toDisplayString(i.key), 9, _hoisted_79))
                            }), 128))
                          ], 2), [
                            [_vModelSelect, _ctx.orgRisksTab.business]
                          ]),
                          (_ctx.v$.orgRisksTab.business.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                (_ctx.v$.orgRisksTab.business.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_82, [
                          _cache[66] || (_cache[66] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["inputboxstylingForSelect", { 'is-invalid': _ctx.v$.orgRisksTab.financial.$error,'inputboxstylingForSelectAtPopup': _ctx.orgRisksTab.financial === '','stylingForInputboxstylingForSelectAtPopup': _ctx.orgRisksTab.financial !== ''  }]),
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.orgRisksTab.financial) = $event))
                          }, [
                            _cache[65] || (_cache[65] = _createElementVNode("option", {
                              value: "",
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, "Please select one", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbFinancial, (i) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "optionColors",
                                value: i.value,
                                key: i
                              }, _toDisplayString(i.key), 9, _hoisted_83))
                            }), 128))
                          ], 2), [
                            [_vModelSelect, _ctx.orgRisksTab.financial]
                          ]),
                          (_ctx.v$.orgRisksTab.financial.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                (_ctx.v$.orgRisksTab.financial.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _cache[68] || (_cache[68] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["inputboxstylingForSelect", { 'is-invalid': _ctx.v$.orgRisksTab.operations.$error,'inputboxstylingForSelectAtPopup': _ctx.orgRisksTab.operations === '','stylingForInputboxstylingForSelectAtPopup': _ctx.orgRisksTab.operations !== ''  }]),
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.orgRisksTab.operations) = $event))
                          }, [
                            _cache[67] || (_cache[67] = _createElementVNode("option", {
                              value: "",
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, "Please select one", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbOperations, (i) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "optionColors",
                                value: i.value,
                                key: i
                              }, _toDisplayString(i.key), 9, _hoisted_89))
                            }), 128))
                          ], 2), [
                            [_vModelSelect, _ctx.orgRisksTab.operations]
                          ]),
                          (_ctx.v$.orgRisksTab.operations.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                (_ctx.v$.orgRisksTab.operations.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_91, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_92, [
                          _cache[70] || (_cache[70] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["inputboxstylingForSelect", { 'is-invalid': _ctx.v$.orgRisksTab.legal.$error,'inputboxstylingForSelectAtPopup': _ctx.orgRisksTab.legal === '','stylingForInputboxstylingForSelectAtPopup': _ctx.orgRisksTab.legal !== ''  }]),
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.orgRisksTab.legal) = $event))
                          }, [
                            _cache[69] || (_cache[69] = _createElementVNode("option", {
                              value: "",
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, "Please select one", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbLegal, (i) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "optionColors",
                                value: i.value,
                                key: i
                              }, _toDisplayString(i.key), 9, _hoisted_93))
                            }), 128))
                          ], 2), [
                            [_vModelSelect, _ctx.orgRisksTab.legal]
                          ]),
                          (_ctx.v$.orgRisksTab.legal.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                (_ctx.v$.orgRisksTab.legal.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _cache[77] || (_cache[77] = _createElementVNode("h1", { class: "upperspacing" }, "Risk Analysis", -1)),
                    _cache[78] || (_cache[78] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, [
                          _cache[72] || (_cache[72] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["inputboxstylingForSelect", { 'is-invalid': _ctx.v$.orgRisksTab.likelihood.$error,'inputboxstylingForSelectAtPopup': _ctx.orgRisksTab.likelihood === '','stylingForInputboxstylingForSelectAtPopup': _ctx.orgRisksTab.likelihood !== ''  }]),
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.orgRisksTab.likelihood) = $event))
                          }, [
                            _cache[71] || (_cache[71] = _createElementVNode("option", {
                              value: "",
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, "Please select one", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbLikelihood, (i) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "optionColors",
                                value: i.value,
                                key: i
                              }, _toDisplayString(i.key), 9, _hoisted_99))
                            }), 128))
                          ], 2), [
                            [_vModelSelect, _ctx.orgRisksTab.likelihood]
                          ]),
                          (_ctx.v$.orgRisksTab.likelihood.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                (_ctx.v$.orgRisksTab.likelihood.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_101, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_102, [
                          _cache[74] || (_cache[74] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: "inputboxstyling",
                            disabled: "",
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.orgRisksTab.overallImpact) = $event))
                          }, [
                            _cache[73] || (_cache[73] = _createElementVNode("option", {
                              value: "",
                              selected: "",
                              hidden: ""
                            }, "Please select one", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSeverity, (i) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: i.value,
                                key: i
                              }, _toDisplayString(i.key), 9, _hoisted_103))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.orgRisksTab.overallImpact]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButton,
                    class: _normalizeClass(["btnprimary mr-2 gap-2", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onCancelButton('cancel')))
                  }, "Reset", 10, _hoisted_105),
                  (_ctx.addingRisk)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.addOrUpdaterisk(_ctx.orgRisksTab)))
                      }, "Save", 10, _hoisted_106))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.addOrUpdaterisk(_ctx.orgRisksTab)))
                      }, "Update", 10, _hoisted_107))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}